import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { useTheme } from '../../context/ThemeContext';
import krydaIcon from '../../assets/kryda-icon.png';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-left">
        <img src={krydaIcon} alt="Kryda Cloud" className="header-kryda-logo" />
        <span className="product-name">Vaultize</span>
        <span className="divider">/</span>
        <span className="user-info">Console</span>
      </div>

      <div className="dashboard-actions">
        {/* Theme Toggle – UI only */}
        <button
          className={`theme-toggle ${theme}`}
          onClick={toggleTheme}
          aria-label="Toggle theme"
          title="Switch theme"
        >
          <span className="toggle-thumb" />
        </button>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
